// extracted by mini-css-extract-plugin
export default {"container":"Yk-z","blurb":"Zk-z","links":"_k-z"};